module.exports = __webpack_public_path__ + "static/media/35.404e609d.jpeg";